import { render } from "./IdentityVerificationView.vue.ts?vue&type=template&id=1606c25d&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IdentityVerificationView.vue?vue&type=template&id=1606c25d&ts=true"
import script from "./IdentityVerificationView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IdentityVerificationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdentityVerificationView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IdentityVerificationView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/credit-line/views/Withdraw/IdentityVerificationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1606c25d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1606c25d', __exports__)) {
    api.reload('1606c25d', __exports__)
  }
  
  module.hot.accept("./IdentityVerificationView.vue.ts?vue&type=template&id=1606c25d&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IdentityVerificationView.vue?vue&type=template&id=1606c25d&ts=true", () => {
    api.rerender('1606c25d', render)
  })

}


export default __exports__